<!-- Struct 表格 类型: b -->

<template>
  <div class="household-form-table-wrap">
    <fieldset>
      <legend>
        <span class="title-item">{{structItem.structName}}</span>
        <el-button v-if="isEdit && isReference" size="mini" type="text" @click="handleClick">引用</el-button>
        <div class="log-icon" v-if="isEdit">
          <gov-table-log-popups
            @revert="handleRevertData"
            :household-id="householdId"
            :struct-id="structItem.id"
            :project-id="projectId"
          ></gov-table-log-popups>
        </div>
        <!-- <div v-show="isEdit" class="title-item copy-btn" @click="handleCopyCaliber">复制</div> -->
      </legend>
      <el-table
        stripe
        class="w100"
        border
        show-summary
        sum-text="合计"
        :summary-method="getSummaries"
        :data="tableData"
      >
        <el-table-column type="index" width="50" label="序号" align="center" :index="1"></el-table-column>
        <!-- <el-table-column
        label="序号"
        width="50"
        prop="row"
      >
        </el-table-column>-->
        <el-table-column
          min-width="200"
          v-for="col in columns"
          :prop="col.prop"
          :filterPlacement="col.isMust"
          :render-header="renderHeader"
          :label="col.name"
          :key="col.id"
        >
          <template slot-scope="scope">
            <gov-survey-code-popups
              v-if="col.type === 'bn'"
              :disabled="!isEdit || col.isRead === 1"
              :project-id="projectId"
              v-model="scope.row[col.prop].value"
              :select-text="scope.row[col.prop].value"
            ></gov-survey-code-popups>
            <!-- <el-cascader
            v-if="col.type === 'bn'"
            change-on-select
            size="small"
            filterable
            :disabled="!isEdit || col.isRead === 1"
            :props="props"
            v-model="scope.row[col.prop].value">
            </el-cascader>-->
            <el-input
              v-model="scope.row[col.prop].value"
              size="small"
              v-if="col.type === 't'"
              :disabled="!isEdit || col.isRead === 1"
            >
              <template slot="append" v-if="col.unitId">{{col.unitName}}</template>
            </el-input>
            <el-input
              v-model="scope.row[col.prop].value"
              size="small"
              v-if="col.type === 'ta'"
              :disabled="!isEdit || col.isRead === 1"
            >
              <template slot="append" v-if="col.unitId">{{col.unitName}}</template>
            </el-input>
            <gov-measure-tool
              v-model="scope.row[col.prop].value"
              :dot="col.dot"
              :unit-id="col.unitId"
              :unit-name="col.unitName"
              v-if="col.type === 'di'"
              :disabled="!isEdit || col.isRead === 1"
            ></gov-measure-tool>
            <!-- <el-input
            v-model="scope.row[col.prop].value"
            v-if="col.type === 'di'"
            :disabled="!isEdit"
            >
            <template slot="append" v-if="col.unitId">{{col.unitName}}</template>
            </el-input>-->
            <!-- onkeyup="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')" -->
            <el-input
              onkeyup="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
              size="small"
              @change="checkDot(scope.row[col.prop].value, col.dot, col.prop, scope.$index)"
              v-model="scope.row[col.prop].value"
              v-if="col.type === 'n'"
              :disabled="!isEdit || col.isRead === 1"
              class="w100"
            >
              <template slot="append" v-if="col.unitId">{{col.unitName}}</template>
            </el-input>
            <el-select
              v-model="scope.row[col.prop].value"
              v-if="col.type === 'm'"
              size="small"
              multiple
              clearable
              :disabled="!isEdit || col.isRead === 1"
              class="w100"
            >
              <el-option
                v-for="op in col.selectOptions"
                :key="op.id"
                :label="op.value"
                :value="op.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="scope.row[col.prop].value"
              v-if="col.type === 's'"
              size="small"
              clearable
              :disabled="!isEdit || col.isRead === 1"
              class="w100"
            >
              <el-option
                v-for="op in col.selectOptions"
                :key="op.id"
                :label="op.value"
                :value="op.value"
              ></el-option>
            </el-select>
            <el-date-picker
              v-if="col.type ==='d'"
              size="small"
              clearable
              v-model="scope.row[col.prop].value"
              value-format="yyyy-MM-dd"
              type="date"
              class="w100"
              :disabled="!isEdit || col.isRead === 1"
              placeholder="选择日期"
            ></el-date-picker>
            <el-date-picker
              v-if="col.type ==='dt'"
              size="small"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="scope.row[col.prop].value"
              type="datetime"
              :disabled="!isEdit || col.isRead === 1"
              class="w100"
              placeholder="选择时间"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="isEdit" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleAdd(scope.row)">新增</el-button>
            <!-- <el-button
            size="mini"
            type="text"
            @click="handleDel(scope.row.row)">
            删除
            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </fieldset>
  </div>
</template>

<script>
// import { convertArrToTree } from '@/utils';
// import { getSurveyOptions } from '@/api/project/household-common.api';
import GovMeasureTool from './measure-tool';
import { addition } from '@/untils/math';
// import { mapActions } from 'vuex';

export default {
  components: {
    GovMeasureTool
  },
  props: {
    householdId: {
      type: String
    },
    isReference: {
      type: Boolean,
      default: true
    },
    isSet: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      required: true
    },
    projectId: {
      type: String
    },
    tableColumns: {
      type: Array,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    },
    structItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    showDel() {
      return this.tableData.length > 1;
    },
    columns() {
      if (Array.isArray(this.tableColumns)) {
        return this.tableColumns.map(item => {
          let title = item.structName;
          let options = [];
          if (item.unitName) {
            title = item.structName + '(' + item.unitName + ')';
          }
          if (item.structType === 's' || item.structType === 'm') {
            options = item.structItemList;
          }
          const columnItem = {
            id: item.id,
            isMust: item.isMust + '',
            isRead: item.isRead,
            prop: item.id,
            name: title,
            type: item.structType,
            unitId: item.unitId,
            unitName: item.unitName,
            dot: item.dot,
            selectOptions: options || []
          };
          return columnItem;
          // columns.push(columnItem);
        });
      }
      return [];
    }
  },
  data() {
    return {};
  },
  methods: {
    // 回退数据
    handleRevertData(data) {
      this.$emit('revert', data, this.structItem.id);
    },
    // 生成表头columns
    // 生成表头
    renderHeader(h, { column }) {
      const isMust = column.filterPlacement;
      if (isMust === '1') {
        return (
          <p>
            <span style="color: red;">*</span>
            {column.label}
          </p>
        );
      }
      return column.label;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(
          item => item[column.property] && item[column.property].value
        );
        const types = data.map(
          item => item[column.property] && item[column.property].type
        );
        if (
          !values.every(value => isNaN(value)) &&
          types.every(type => type === 'n')
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(addition(Number(prev), Number(curr)));
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = '--';
        }
      });
      return sums;
    },
    handleAdd(row) {
      this.$emit('add-table-row-data', this.structItem);
      // this.addTableRowData(this.structItem);
    },
    handleConfirmDelete(data) {
      this.$emit('del-table-row-data', {
        row: data.row,
        structItem: this.structItem
      });
    },
    checkDot(value, dot, prop, index) {
      if (dot !== null) {
        if (isNaN(value)) {
          this.$message.warning('当前限制只能输入数字');
        }
        if (Number(value) === 0) {
          this.tableData[index][prop].value = '';
        }
        if (value.indexOf('.') !== -1) {
          if (value.toString().split('.')[1].length > dot) {
            this.$message.warning(`当前限制小数点后${dot}位`);
            if (dot === 0) {
              this.tableData[index][prop].value = value.substring(
                0,
                value.indexOf('.')
              );
            } else {
              this.tableData[index][prop].value = value.substring(
                0,
                value.indexOf('.') + dot + 1
              );
            }
          }
        }
      }
    },
    handleClick() {
      this.$emit('reference', this.structItem.id);
    }
  }
};
</script>

<style>
.household-form-table-wrap {
}
fieldset {
  border: 1px solid #e3e3e3;
  min-width: 100px;
  padding: 10px;
}
.log-icon {
  display: inline-block;
}
legend {
  padding: 0 10px;
  margin-left: 20px;
}
.title-item {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/form-struct.table.vue